import { clearSessionStorage, SSU_SESSION_ID } from 'config/storage';
import type { AppRouterContext } from 'providers/AppRouter';
import {
  getLeadQueryKey,
  resolveLeadQueryVariables,
} from 'services/partnersSelfSignup/signup';
import { experimentVariantManager } from 'utils/experimentation';

/**
 * Prepares the signup route before loading by clearing relevant query cache and session storage.
 *
 * This function removes the cached queries related to the current lead from the query client,
 * and clears session storage. If there is no lead id, the function returns early.
 *
 * @param context - The router context containing the query client instance.
 */
export function onEnterIndexRoute({
  context,
  preload,
}: {
  context: AppRouterContext;
  preload: boolean;
}) {
  if (preload) return;
  const { queryClient } = context ?? {};

  const { leadId } = resolveLeadQueryVariables(queryClient);
  if (!leadId) return;
  const queryKey = getLeadQueryKey({ leadId });

  experimentVariantManager.clear();

  queryClient.invalidateQueries({
    queryKey: ['features', sessionStorage.getItem(SSU_SESSION_ID)],
    exact: true,
  });

  queryClient.removeQueries({ queryKey, exact: true });
  clearSessionStorage(queryClient, false);
}
